export default "__VITE_ASSET__DVVjzSUA__"